import { createI18n } from 'vue-i18n'
import sellerEn from '../locales/seller/en.json'
import sellerZhCN from '../locales/seller/zh-CN.json'
import sellerExtraEn from '../locales/seller/extra-en.json'
import sellerExtraZhCN from '../locales/seller/extra-zh-CN.json'
import helpDocsAboutArtemis1En from '../locales/seller/help-docs-about-artemis-1.en.json'
import helpDocsAboutArtemis2En from '../locales/seller/help-docs-about-artemis-2.en.json'
import helpDocsAboutArtemis1ZhCN from '../locales/seller/help-docs-about-artemis-1.zh-CN.json'
import helpDocsAboutArtemis2ZhCN from '../locales/seller/help-docs-about-artemis-2.zh-CN.json'

function deepMerge(a, b) {
  const out = Array.isArray(a) ? [...a] : { ...a }
  if (!b) return out
  for (const k of Object.keys(b)) {
    const av = out[k]
    const bv = b[k]
    if (bv && typeof bv === 'object' && !Array.isArray(bv) && typeof av === 'object' && av !== null && !Array.isArray(av)) {
      out[k] = deepMerge(av, bv)
    } else {
      out[k] = bv
    }
  }
  return out
}

const messagesEn = deepMerge(
  deepMerge(deepMerge(sellerEn, sellerExtraEn), helpDocsAboutArtemis1En),
  helpDocsAboutArtemis2En
)
const messagesZhCN = deepMerge(
  deepMerge(deepMerge(sellerZhCN, sellerExtraZhCN), helpDocsAboutArtemis1ZhCN),
  helpDocsAboutArtemis2ZhCN
)

const STORAGE_SUFFIX = '_sellerLocale'

function normalizeSellerLocale(locale) {
  return locale === 'zh-CN' || locale === 'en' ? locale : null
}

function getLocaleStorageKey(accountId) {
  const base = `${location.hostname}${STORAGE_SUFFIX}`
  if (accountId != null && accountId !== '') {
    return `${base}_${accountId}`
  }
  return base
}

/** 读取指定 seller 账号的语言偏好；无账号 id 时读站点级默认 */
export function getStoredSellerLocale(accountId) {
  try {
    if (accountId != null && accountId !== '') {
      const perAccount = normalizeSellerLocale(
        localStorage.getItem(getLocaleStorageKey(accountId)),
      )
      if (perAccount) return perAccount
    }
    return normalizeSellerLocale(localStorage.getItem(getLocaleStorageKey()))
  } catch (e) {
    /* ignore */
  }
  return null
}

/** seller 端无本地记录时的默认语言 */
export const DEFAULT_SELLER_LOCALE = 'en'

function getStoredLocale() {
  return getStoredSellerLocale() || DEFAULT_SELLER_LOCALE
}

/** @param {string} locale - 'en' | 'zh-CN' */
/** @param {string|number} [accountId] - seller 用户 id，有则按账号持久化 */
export function persistSellerLocale(locale, accountId) {
  const normalized = normalizeSellerLocale(locale)
  if (!normalized) return
  try {
    localStorage.setItem(getLocaleStorageKey(accountId), normalized)
  } catch (e) {
    /* ignore */
  }
}

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getStoredLocale(),
  fallbackLocale: 'en',
  messages: {
    en: messagesEn,
    'zh-CN': messagesZhCN,
  },
  missingWarn: false,
  fallbackWarn: false,
})

/** API 请求头 Accept-Language：英文 en-US，简体中文 zh-CN */
export function getAcceptLanguageHeader() {
  try {
    const raw = i18n.global.locale
    const loc = typeof raw === 'string' ? raw : raw?.value
    return loc === 'zh-CN' ? 'zh-CN' : 'en-US'
  } catch (e) {
    return getStoredLocale() === 'zh-CN' ? 'zh-CN' : 'en-US'
  }
}

export default i18n
